<template>
  <div class="card modal-card">
    <div class="modal-card-body">
      <div class="card-content is-paddingless">
        <div class="mgb-50px">
          <h1 class="title is-size-3 has-text-centered">
            {{ $t('dcf.remise.netFace.title') }}
          </h1>
        </div>
      </div>
      <div class="columns">
        <div class="column is-6">
          <b-field :label="$t('dcf.remise.netFace.libelle')">
            <b-input v-model="libelle"></b-input>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('dcf.remise.netFace.prixNet')">
            <input-currency v-model="prixNet">
            </input-currency>
          </b-field>
        </div>
      </div>
      <footer>
        <button
          class="button btn-modal-annuler is-cancel has-text-centered button-modal mgl-0"
          @click="$parent.close()">
          {{ $t('general.button.cancel')}}
        </button>
        <button
          class="button is-addOrEdit has-text-centered button-modal"
          @click="addPrixNetFace" >
          {{ $t('general.button.terminer')}}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import inputCurrency from '@/components/general/inputCurrency';
import messageErreur from '@/services/general/messageErreur';
import genererLigneRemise from '@/services/devisCommandes/genererLigneRemise';
import findPourcentageRemise from '@/services/devisCommandes/findPourcentageRemise';
import * as remiseF2B from '@/services/devisCommandes/traductionRemiseBackFront';
import { CATEGORIE_LOCATION } from '@/configuration/catalogue/produitConf';
import calculLignesRemise from '@/services/devisCommandes/calcul/calculLignesRemise';
import { PERSONALISE } from '@/configuration/devisConf';

export default {
  props: {
    lignes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      libelle: '',
      prixNet: 0,
    };
  },
  components: {
    inputCurrency,
  },
  methods: {
    addPrixNetFace() {
      if (!this.prixNet) {
        messageErreur(this.$i18n, this.$i18n.t('dcf.messages.errors.prixNetFaceSouhaiteNull'));
        return;
      }
      const ligneRemise = genererLigneRemise();
      ligneRemise.libelle = this.libelle;
      this.lignes.forEach((ligne) => {
        if (ligne.lignesCommande) {
          ligne.lignesCommande.forEach((ligneEnf) => {
            if (ligneEnf.typeProduit !== CATEGORIE_LOCATION) return;
            const ligneRemiseClone = cloneDeep(ligneRemise);
            if (ligneEnf.totalHt === 0) {
              messageErreur(this.$i18n, this.$i18n.t('dcf.messages.errors.remisePrixDepartZero'));
              return;
            }
            const prix = Number(this.prixNet)
              * Number(ligne.ligneReseau.qteFacesSouhaitees);
            findPourcentageRemise(ligneRemiseClone, prix, ligneEnf.totalAvantRemise);
            remiseF2B.fromTypeRemiseFront(ligneRemiseClone, ligneRemiseClone.typeRemise);
            remiseF2B.fromMontantRemiseFront(ligneRemiseClone, ligneRemiseClone.typeRemise,
              ligneRemiseClone.remise);
            ligneEnf.lignesRemise = [ligneRemiseClone];
            ligneEnf.remise = ligneRemiseClone.remise;
            ligneEnf.typeRemise = PERSONALISE;
            calculLignesRemise(ligneEnf);
          });
        }
      });
      this.$emit('remiseNetFace');
    },
  },
};

</script>
